import { Component } from 'preact'
import { SVG } from '.'

export default class Loading extends Component {
  render() {
    return (
      <div class="loading-icon">
        <SVG name="circle" size={this.props.size} />
      </div>
    )
  }
}
